import { render, staticRenderFns } from "./EzamRequest.vue?vue&type=template&id=a1c92866"
import script from "./EzamRequest.vue?vue&type=script&lang=js"
export * from "./EzamRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports